import { useAppDispatch, useAppSelector } from "../../../../store/store";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { EditableProps } from "../../editableProps";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { ProductVariationsNode } from "@common/build/types";
import CheckboxInput from "@builder/components/general/CheckboxInput";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import SliderInput from "@builder/components/general/SliderInput";
import { getValueUnit } from "@builder/components/general/editUtils";
import { getStyle, getStylePath } from "@builder/components/editable/helpers";

const VariantGrid: React.FC<EditableProps> = ({ parent, stateMode }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as ProductVariationsNode;
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const cvModeIndex = cvMode?.id === node?.id ? cvMode.index : null;

    if (!node) return null;

    const styles = getStyle(node, undefined, stateMode, cvModeIndex);
    const stylePath = getStylePath(undefined, stateMode, cvModeIndex);

    const optionWrapperStyle = getStyle(node, ["optionWrapperStyles"], stateMode, cvModeIndex);
    const optionWrapperStylePath = getStylePath(["optionWrapperStyles"], stateMode, cvModeIndex);

    //Align Items
    const alignItems = styles.stateStyle?.alignItems || styles.default?.alignItems;
    const alignOptions = [
        { value: "flex-start", img: "/align-start.svg", checked: "flex-start" === alignItems, tooltip: "Left" },
        { value: "center", img: "/align-center.svg", checked: "center" === alignItems, tooltip: "Center" },
        { value: "flex-end", img: "/align-end.svg", checked: "flex-end" === alignItems, tooltip: "Right" }
    ];
    const toggleAlignCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...stylePath, "alignItems"], value }));
    };

    //Options gap
    const optionGapString = (optionWrapperStyle.stateStyle?.gap || optionWrapperStyle.default?.gap) as string;
    const optionGap = getValueUnit(optionGapString);
    const optionCallback = (value: string, unit: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...optionWrapperStylePath, "gap"], value: value + unit }));
    };

    //Gap between sections
    const gapString = (styles.stateStyle?.gap || styles.default?.gap) as string;
    const gap = getValueUnit(gapString);
    const gapCallback = (value: string, unit: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...stylePath, "gap"], value: value + unit }));
    };

    //Gap between sections
    const widthString = (styles.stateStyle?.width || styles.default?.width) as string;
    const width = getValueUnit(widthString);
    const widthCallback = (value: string, unit: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...stylePath, "width"], value: value + unit }));
    };

    return (
        <SidebarCollapse title="Variant Grid" parent={parent}>
            <CheckboxInput title="Align" options={alignOptions} callback={toggleAlignCallback} />
            <SliderInput title="Variant gap" {...optionGap} min={0} max={30} callback={optionCallback} />
            <SliderInput title="Section gap" {...gap} min={0} max={30} callback={gapCallback} />
            <SliderInput title="Width" {...width} min={200} max={800} callback={widthCallback} />
        </SidebarCollapse>
    );
};

export default VariantGrid;
